import { PosthogService } from "@/services/posthog";
import * as sentry from "@sentry/react";
import { tiktokCompleteRegistration } from "./trackTiktokAnalytics";

const trackPosthogAnalytics = (
  eventName: string,
  data: Record<string, unknown> = {},
) => {
  const defaultOptions = {
    platform: "website",
    location: window.location.pathname,
  };

  try {
    PosthogService.capture(eventName, { ...defaultOptions, ...data });
  } catch (e) {
    console.error(`Error in trackPosthogAnalytics: ${eventName}`, e);
    sentry.captureException(e);
  }
};

export const trackSignupEvent = (
  email: string,
  uid: string,
  signupType?: string,
) => {
  PosthogService.capture("User Signed Up", {
    $set: { email, uid },
    $set_once: { signup_through_website: true, sign_up: true },
    signuptype: signupType ?? "NA",
  });

  try {
    tiktokCompleteRegistration;
  } catch (error) {
    sentry.captureException(error);
  }
};

export const identifyUser = (uid: string, email: string) => {
  PosthogService.identify(email, {
    email,
    uid,
  });
};

export default trackPosthogAnalytics;
